
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/breadcrumbs",
      function () {
        return require("private-next-pages/joy-ui/api/breadcrumbs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/breadcrumbs"])
      });
    }
  